<template>
  <v-container fluid>
    <v-row>
      <v-col
        cols="12"
        md="8"
      >
        <v-form v-model="isFormValid">
          <material-card
            heading="예약정보"
            icon-small
            icon="mdi-book-open-outline"
            title="예약정보"
            color="primary"
          >
            <v-row
              class="pl-10 pr-10 mb-minus-20"
            >
              <v-col
                v-if="$vuetify.breakpoint.mdAndUp"
                cols="12"
                md="2"
                style="margin-top: 15px;"
              >
                <span style="color: red;">*</span> 회의명
              </v-col>
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-model="meetingInfo.title"
                  label="회의명"
                  outlined
                  :rules="[rules.required]"
                  :dense="!$vuetify.breakpoint.mdAndUp"
                />
              </v-col>
            </v-row>
            <v-row
              class="pl-10 pr-10 mb-minus-20"
            >
              <v-col
                v-if="$vuetify.breakpoint.mdAndUp"
                cols="12"
                md="2"
                style="margin-top: 15px;"
              >
                설명
              </v-col>
              <v-col
                cols="12"
                md="8"
              >
                <v-text-field
                  v-model="meetingInfo.contents"
                  label="설명"
                  outlined
                  :dense="!$vuetify.breakpoint.mdAndUp"
                />
              </v-col>
            </v-row>
            <v-row
              class="pl-10 pr-10 mb-minus-20"
            >
              <v-col
                v-if="$vuetify.breakpoint.mdAndUp"
                cols="12"
                md="2"
                style="margin-top: 15px;"
              >
                <span style="color: red;">*</span> 일시
              </v-col>
              <v-col
                cols="12"
                md="10"
              >
                <div
                  :style="$vuetify.breakpoint.lgAndUp ? { float: 'left', width: '150px', marginRight: '5px' } : {}"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="meetingInfo.reservedDate"
                    :disabled="meetingInfo.status === 's'"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="meetingInfo.reservedDate"
                        label="시작 일시"
                        readonly
                        outlined
                        :dense="!$vuetify.breakpoint.mdAndUp"
                        :rules="[rules.required]"
                        :disabled="meetingInfo.status === 's'"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="meetingInfo.reservedDate"
                      no-title
                      scrollable
                      :allowed-dates="allowedDates"
                      :disabled="meetingInfo.status === 's'"
                      @change="reservedDateChange"
                      @input="$refs.menu.save(meetingInfo.reservedDate)"
                    />
                  </v-menu>
                </div>
                <div
                  :style="$vuetify.breakpoint.lgAndUp ? { float: 'left', width: '150px' } : {}"
                >
                  <v-select
                    v-model="meetingInfo.startTime"
                    :items="startTimeList"
                    menu-props="auto"
                    label="시작 시간"
                    single-line
                    outlined
                    :dense="!$vuetify.breakpoint.mdAndUp"
                    :disabled="meetingInfo.status === 's'"
                    :rules="[rules.required]"
                    @change="startTimeChange"
                  />
                </div>
                <div
                  v-if="$vuetify.breakpoint.lgAndUp"
                  style="float: left; margin-top: 15px; margin-left: 10px; width: 20px;"
                >
                  ~
                </div>
                <div
                  :style="$vuetify.breakpoint.lgAndUp ? { float: 'left', width: '150px', marginRight: '5px' } : {}"
                >
                  <v-menu
                    ref="menu1"
                    v-model="menu1"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="meetingInfo.reservedEndDate"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="meetingInfo.reservedEndDate"
                        label="종료 일시"
                        outlined
                        readonly
                        :dense="!$vuetify.breakpoint.mdAndUp"
                        :rules="[rules.required]"
                        v-on="on"
                      />
                    </template>
                    <v-date-picker
                      v-model="meetingInfo.reservedEndDate"
                      no-title
                      scrollable
                      :allowed-dates="allowedEndDates"
                      @change="reservedEndDateChange"
                      @input="$refs.menu1.save(meetingInfo.reservedEndDate)"
                    >
                      <v-spacer/>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div
                  :style="$vuetify.breakpoint.lgAndUp ? { float: 'left', width: '150px' } : {}"
                >
                  <v-select
                    v-model="meetingInfo.endTime"
                    :items="endTimeList"
                    menu-props="auto"
                    label="종료 시간"
                    single-line
                    outlined
                    :dense="!$vuetify.breakpoint.mdAndUp"
                    :rules="[rules.required]"
                    @change="endTimeChange"
                  />
                </div>
                <div
                  v-if="$vuetify.breakpoint.lgAndUp"
                  style="float: left;"
                >
                  <v-btn-toggle
                    v-model="meetingInfo.isRepeat"
                    @change="customDialog.dialog = !customDialog.dialog"
                  >
                    <v-btn
                      :value="true"
                      class="ml-2"
                      outlined
                      large
                      color="primary"
                      :dense="!$vuetify.breakpoint.mdAndUp"
                    >
                      <v-icon>
                        mdi-refresh
                      </v-icon>
                      반복
                    </v-btn>
                  </v-btn-toggle>
                </div>
              </v-col>
            </v-row>

            <v-row class="pl-10 pr-10 mb-minus-20">
              <v-col
                v-if="$vuetify.breakpoint.mdAndUp"
                cols="12"
                md="2"
                style="margin-top: 15px;"
              >
                <span style="color: red;">*</span> 회의실
              </v-col>
              <v-col
                cols="12"
                md="8"
              >
                <v-select
                  v-model="meetingInfo.roomIds"
                  ref="inputByRooms"
                  outlined
                  label="회의실"
                  item-value="_id"
                  item-text="name"
                  return-object
                  :items="rooms"
                  :rules="[rules.required]"
                  :dense="!$vuetify.breakpoint.mdAndUp"
                  @change="changeRoom"
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-avatar>
                      <v-icon color="primary">
                        mdi-map-marker
                      </v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        v-if="item.isPublic !== undefined && item.isPublic !== null && item.isPublic !== false">
                        (공용) {{ item.name }}
                      </v-list-item-title>
                      <v-list-item-title v-else>
                        {{ item.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ item.buildingName }} / {{ item.typeName }}
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        수용 인원 : {{ item.capacity }} 명
                      </v-list-item-subtitle>
                      <v-list-item-subtitle v-if="item.items !== null && item.items !== ''">
                        장비 : {{ item.items }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-select>
              </v-col>
            </v-row>

            <v-row
              v-if="$vuetify.breakpoint.mdAndUp"
              class="pl-10 pr-10"
              style="margin-top: -60px;"
            >
              <v-col
                v-if="$vuetify.breakpoint.mdAndUp"
                cols="12"
                md="2"
                style="margin-top: 15px;"
              />
              <v-col
                cols="12"
                md="8"
              >
                <v-checkbox
                  v-model="isIgnoreDuplicateRooms"
                  label="예약가능한 회의실 보기"
                  @change="availableRooms"
                />
              </v-col>
            </v-row>

            <v-row
              class="pl-10 pr-10 mb-minus-20"
            >
              <v-col
                v-if="$vuetify.breakpoint.mdAndUp"
                cols="12"
                md="2"
                style="margin-top: 15px;"
              >
                참석자
              </v-col>
              <v-col
                cols="12"
                md="8"
              >
                <div>
                  <v-combobox
                    ref="userList"
                    v-model="meetingInfo.attendees"
                    :loading="loading"
                    label="참석자"
                    :items="people"
                    item-text="displayFullName"
                    item-value="email"
                    multiple
                    chips
                    :search-input.sync="searchAttendees"
                    outlined
                    return-object
                    :dense="!$vuetify.breakpoint.mdAndUp"
                  >
                    <template v-slot:selection="{ attrs, item, parent, selected }">
                      <v-chip
                        class="chip--select-multi"
                        close
                        v-bind="attrs"
                        dark
                        color="success"
                        :small="!$vuetify.breakpoint.mdAndUp"
                        :input-value="selected"
                        @input="parent.selectItem(item)"
                        @click:close="chipClose('reserve' ,item)"
                      >
                        <v-avatar>
                          <v-icon>
                            mdi-account-circle
                          </v-icon>
                        </v-avatar>
                        <span class="white--text">
                          {{
                            item.displayFullName
                              ? item.displayFullName
                              : item.username
                                ? item.username
                                : item.displayName
                          }}
                        </span>
                      </v-chip>
                    </template>
                    <template
                      slot="item"
                      slot-scope="data"
                    >
                      <v-list-item-icon>
                        <v-icon blue>
                          mdi-account-circle
                        </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="data.item.displayFullName
                            ? data.item.displayFullName
                            : data.item.username + '/' + data.item.department + '/' + data.item.title"
                        />
                        <v-list-item-subtitle v-html="data.item.email"/>
                      </v-list-item-content>
                    </template>
                  </v-combobox>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-spacer/>
              <v-col
                cols="auto"
                class="pr-10"
              >
                <v-btn
                  class="mr-2 lighten-1"
                  :color="isEdit ? 'orange' : 'primary'"
                  dark
                  :loading="loading"
                  :fab="!$vuetify.breakpoint.mdAndUp"
                  @click="reserveMeeting()"
                >
                  <v-icon>
                    mdi-check
                  </v-icon>
                  {{ $vuetify.breakpoint.mdAndUp ? isEdit ? '수정' : '예약' : '' }}
                </v-btn>
                <v-btn
                  v-if="isEdit"
                  class="mr-2"
                  color="error darken-1"
                  :fab="!$vuetify.breakpoint.mdAndUp"
                  @click="cancelMeeting()"
                >
                  <v-icon>
                    mdi-trash-can-outline
                  </v-icon>
                  {{ $vuetify.breakpoint.mdAndUp ? '취소' : '' }}
                </v-btn>
                <v-btn
                  color="grey darken-1"
                  dark
                  :fab="!$vuetify.breakpoint.mdAndUp"
                  @click="goBack()"
                >
                  <v-icon>
                    mdi-keyboard-backspace
                  </v-icon>
                  {{ $vuetify.breakpoint.mdAndUp ? '이전' : '' }}
                </v-btn>
              </v-col>
            </v-row>
          </material-card>
        </v-form>
      </v-col>
      <v-col
        v-show="$vuetify.breakpoint.mdAndUp"
        cols="12"
        md="4"
      >
        <material-card
          heading="회의실 예약 현황"
          icon-small
          icon="mdi-calendar"
          title="회의실 예약 현황"
          color="secondary"
        >
          <v-row>
            <v-col>
              <v-sheet height="650">
                <v-calendar
                  ref="calendar"
                  v-model="value"
                  type="day"
                  :events="meetings"
                  :event-color="getEventColor"
                  :start="meetingInfo.reservedDate"
                >
                  <template v-slot:day-body="{ date, week }">
                    <div
                      class="v-current-time"
                      :class="{ first: date === week[0].date }"
                      :style="{ top: nowY }"
                    />
                  </template>
                </v-calendar>
              </v-sheet>
            </v-col>
          </v-row>
        </material-card>
      </v-col>
    </v-row>
    <custom-dialog
      :title="customDialog.title"
      :dialog="customDialog.dialog"
      :to-parent="repeatInfoDialogClose"
      :max-width="500"
    >
      <div slot="content">
        <v-form v-model="customDialog.isFormValid">
          <v-row class="text-center">
            <v-col cols="12">
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-select
                      v-model="meetingInfo.repeatInfo.type"
                      :items="repeatTypes"
                      outlined
                      hide-details
                      dense
                      label="반복 타입"
                      :rules="[rules.required]"
                      @change="repeatTypeChanged"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="meetingInfo.repeatInfo.interval"
                      prepend-inner-icon="mdi-refresh"
                      outlined
                      hide-details
                      dense
                      label="반복 주기"
                      type="number"
                      min="1"
                      :max="meetingInfo.repeatInfo.type === 'DAILY'
                        ? 31
                        : meetingInfo.repeatInfo.type === 'WEEKLY'
                          ? 4
                          : 12"
                      :rules="[rules.required]"
                    />
                  </v-col>
                  <v-col
                    v-if="meetingInfo.repeatInfo.type !== 'DAILY'"
                    cols="12"
                    sm="6"
                  >
                    <v-select
                      v-if="meetingInfo.repeatInfo.type === 'WEEKLY'"
                      v-model="meetingInfo.repeatInfo.byDay"
                      :items="weeks"
                      label="요일 선택"
                      multiple
                      dense
                      chips
                      outlined
                      hide-details
                      :rules="[rules.required]"
                      @blur="byDayChanged"
                    />
                    <v-select
                      v-else
                      v-model="meetingInfo.repeatInfo.monthType"
                      :items="monthType"
                      label="월별 타입"
                      dense
                      outlined
                      hide-details
                      :rules="meetingInfo.repeatInfo.type === 'MONTHLY' ? [rules.required] : []"
                    />
                  </v-col>
                  <v-col
                    v-if="meetingInfo.repeatInfo.type === 'MONTHLY' && meetingInfo.repeatInfo.monthType === 'day'"
                    cols="12"
                    sm="6"
                  >
                    <v-text-field
                      v-model="meetingInfo.repeatInfo.monthDay"
                      prepend-inner-icon="mdi-calendar-month-outline"
                      outlined
                      hide-details
                      dense
                      label="일자"
                      type="number"
                      min="1"
                      max="31"
                      :rules="meetingInfo.repeatInfo.type === 'MONTHLY' ? [rules.required] : []"
                    />
                  </v-col>
                  <v-col
                    v-if="meetingInfo.repeatInfo.type === 'MONTHLY' && meetingInfo.repeatInfo.monthType === 'week'"
                  >
                    <v-select
                      v-model="meetingInfo.repeatInfo.monthWeek"
                      :items="[ 1, 2, 3, 4 ]"
                      label="몇째주"
                      dense
                      outlined
                      hide-details
                      :rules="meetingInfo.repeatInfo.type === 'MONTHLY' ? [rules.required] : []"
                    />
                  </v-col>
                  <v-col
                    v-if="meetingInfo.repeatInfo.type === 'MONTHLY' && meetingInfo.repeatInfo.monthType === 'week'"
                  >
                    <v-select
                      v-model="meetingInfo.repeatInfo.monthDayOfWeek"
                      :items="weeks"
                      label="요일 선택"
                      dense
                      outlined
                      hide-details
                      :rules="meetingInfo.repeatInfo.type === 'MONTHLY' ? [rules.required] : []"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                  >
                    <v-menu
                      ref="repeatMenu"
                      v-model="repeatMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="meetingInfo.repeatInfo.endDate"
                          label="종료일자"
                          outlined
                          dense
                          hide-details
                          readonly
                          prepend-inner-icon="mdi-calendar"
                          :rules="[rules.required]"
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="meetingInfo.repeatInfo.endDate"
                        no-title
                        :allowed-dates="allowedRepeatDates"
                        @input="repeatMenu = false"
                      />
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row
                  v-if="false"
                  class="text-center"
                >
                  <v-col
                    cols="12"
                    md="6"
                  >
                    <!-- <v-btn-toggle
                      v-model="repeat.byDay"
                      dense
                      color="primary"
                      multiple
                    >
                      <v-btn
                        v-for="day in weeks"
                        :key="day.value"
                        small
                        fab
                      >
                        {{ day.text }}
                      </v-btn>
                    </v-btn-toggle> -->
                    <!-- <v-chip-group
                      multiple
                      active-class="primary--text"
                      v-model="repeat.byDay"
                    >
                      <v-chip
                        v-for="day in weeks"
                        :key="day.value"
                      >
                        {{ day.text }}
                      </v-chip>
                    </v-chip-group> -->
                    <v-select
                      v-model="meetingInfo.repeatInfo.byDay"
                      :items="weeks"
                      label="요일 선택"
                      multiple
                      dense
                      chips
                      outlined
                      hide-details
                      return-object
                      @blur="byDayChanged"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                  >
                    test
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-form>
      </div>
    </custom-dialog>
  </v-container>
</template>
<script>
  import moment from 'moment'
  import { isValidateChcker, nearestFutureMinutes, snackbarOpen } from '@/util/helpers'
  import { get } from 'vuex-pathify'
  import debounce from 'lodash.debounce'

export default {

  data: () => ({
    isFormValid: false,
    menu: false,
    menu1: false,
    startTimeList: [],
    endTimeList: [],
    heading: '',
    meeting: {},
    loading: false,
    roomLoading: false,
    rooms: [],
    searchRoomInfo: null,
    meetings: [],
    value: '',
    ready: false,
    people: [],
    lastSearchPeople: [],
    searchAttendees: null,
    meetingInfo: {
      title: '',
      contents: '',
      reservedDate: moment().format('YYYY-MM-DD'),
      startTime: null,
      reservedEndDate: moment().format('YYYY-MM-DD'),
      endTime: null,
      creator: {
        email: '',
        username: '',
        displayFullName: '',
        displayName: '',
      },
      timeZone: 'Asia/Seoul',
      attendees: [],
      roomIds: [],
      isRepeat: false,
      isScheduled: false,
      publicReservedType: false,
      repeatInfo: {
        type: 'DAILY', // null, // daily (DAILY) / weekly (WEEKLY) / monthly (MONTHLY)
        byDay: null, // sunday(SU) / monday(MO) / tuesday(TU) / wednesday(WE) / thursday(TH) / friday(FR) / saturday(SA)
        endDate: moment().format('YYYY-MM-DD'),
        interval: 1, // 간격
        monthType: 'day',
        monthDay: moment().format('DD'),
        monthDayOfWeek: moment().day(),
        monthWeek: moment().weeks() - moment().add(0, 'month').startOf('month').weeks() + 1,
      },
      status: 'r',
    },
    isEdit: false,
    customDialog: {
      title: '반복일정 정보',
      dialog: false,
      isFormValid: false,
    },
    repeatMenu: false,
    repeatTypes: [
      {text: 'Daily', value: 'DAILY'},
      {text: 'Weekly', value: 'WEEKLY'},
      {text: 'Monthly', value: 'MONTHLY'},
    ],
    monthType: [
      {text: '일', value: 'day'},
      // { text: '주차', value: 'week' },
    ],
    weeks: [
      {text: '일', value: '0', sort: 1},
      {text: '월', value: '1', sort: 2},
      {text: '화', value: '2', sort: 3},
      {text: '수', value: '3', sort: 4},
      {text: '목', value: '4', sort: 5},
      {text: '금', value: '5', sort: 6},
      {text: '토', value: '6', sort: 7},
    ],
    rules: {
      required: isValidateChcker.required,
    },
    isIgnoreDuplicateRooms: false,
  }),

  computed: {
    info: get('user/info'),
    cal() {
      return this.ready ? this.$refs.calendar : null
    },
    nowY() {
      return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
    },
  },

  watch: {
    '$vuetify.breakpoint.name': {
      async handler() {
        await this.getRooms()
      },
    },
    searchAttendees: {
      handler(val) {
        // 회의실 선택 유무 체크
        if (this.meetingInfo.roomIds._id !== undefined) {
          this.searchPeople(val)
        } else {
          this.$refs.inputByRooms.focus()
          this.searchAttendees = ''
        }
      },
    },
    'meetingInfo.attendees': {
      handler(val) {
        if (val === undefined) return

        const keyword = this.meetingInfo.attendees[val.length - 1]

        if (typeof keyword === 'string') {
          if (this.lastSearchPeople.length > 0) {
            const findData = this.meetingInfo.attendees.find(x => x.email === this.lastSearchPeople[0].email)
            if (!findData) {
              this.meetingInfo.attendees[val.length - 1] = this.lastSearchPeople[0]
            } else {
              this.meetingInfo.attendees.pop()
            }
          } else {
            this.meetingInfo.attendees.pop()
          }
        }
        this.searchAttendees = null
      },
    },
  },

  async mounted() {
    const meetingId = this.$route.query.meetingId
    const startDtime = this.$route.query.startDtime
    const endDtime = this.$route.query.endDtime
    const roomIds = this.$route.query.roomIds
    if (meetingId) {
      this.isEdit = true
    }

    this.ready = true
    await this.init(meetingId, startDtime, endDtime, roomIds)
    this.scrollToTime()
    this.updateTime()
    await this.getMeetings()
  },

  methods: {
    async init(meetingId, startDtime, endDtime, roomIds) {
      // 시간 combobox bind 하고
      if (this.isEdit) {
        // Edit 모드인 경우 데이터 가져와서 바인딩
        await this.$http.get(`/api/v1/meetings/${meetingId}`).then(response => {
          const meeting = response.data
          this.meetingInfo = {
            ...meeting,
            reservedDate: moment(meeting.startDtime).format('YYYY-MM-DD'),
            reservedEndDate: moment(meeting.endDtime).format('YYYY-MM-DD'),
            startTime: moment(meeting.startDtime).format('HH:mm'),
            endTime: moment(meeting.endDtime).format('HH:mm'),
            roomIds: meeting.roomIds[0],
          }
          const isToday = this.meetingInfo.reservedDate === moment().format('YYYY-MM-DD')
          this.setCombobox(isToday, this.isEdit)
        }).catch(error => {
          // 에러팝업띄우고 뒤로가기
          console.log(error)
        })
      } else {
        const now = moment().format('YYYY-MM-DD')
        const nowPlusThirtyMinutes = startDtime
          ? moment(startDtime).format('YYYY-MM-DD')
          : moment().add(30, 'minutes').format('YYYY-MM-DD')
        if (now !== nowPlusThirtyMinutes) {
          this.meetingInfo.reservedDate = moment().add(1, 'days').format('YYYY-MM-DD')
          this.meetingInfo.reservedEndDate = moment().add(1, 'days').format('YYYY-MM-DD')
          this.setCombobox(false)
        } else {
          this.meetingInfo.reservedDate = moment().format('YYYY-MM-DD')
          this.meetingInfo.reservedEndDate = moment().format('YYYY-MM-DD')
          this.setCombobox(true)
        }

        if (startDtime) {
          this.meetingInfo.reservedDate = moment(startDtime).format('YYYY-MM-DD')
          this.meetingInfo.reservedEndDate = moment(startDtime).format('YYYY-MM-DD')
          this.meetingInfo.startTime = moment(startDtime).format('HH:mm')
          if (endDtime) {
            this.meetingInfo.endTime = moment(endDtime).format('HH:mm')
          } else {
            this.meetingInfo.endTime = moment(startDtime).add(30, 'minutes').format('HH:mm')
          }
        }

        // 마지막 시간인 경우에 종료 일시 날짜를 +1 해주기 위함
        this.reservedDateChange(this.meetingInfo.reservedDate)
      }
      await this.getRooms()

      if (roomIds) {
        // console.log(roomIds)
        this.meetingInfo.roomIds = this.rooms.find(room => room._id === roomIds[0])
      }
    },
    async getRooms() {
      this.roomLoading = true
      // console.log('this.$vuetify.breakpoint.mdAndUp :: ' + this.$vuetify.breakpoint.mdAndUp)
      // console.log('this.isIgnoreDuplicateRooms :: ' + this.isIgnoreDuplicateRooms)

      if (this.$vuetify.breakpoint.mdAndUp && !this.isIgnoreDuplicateRooms) {
        await this.$http.get('/api/v1/rooms').then(response => {
          this.rooms = response.data
          this.roomLoading = false
        }).catch(error => {
          console.log(error)
          this.roomLoading = false
        })
      } else {
        const params = {
          startDtime: moment(`${this.meetingInfo.reservedDate} ${this.meetingInfo.startTime}`).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
          endDtime: moment(`${this.meetingInfo.reservedEndDate} ${this.meetingInfo.endTime}`).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
          meetingId: this.meetingInfo._id,
          isRepeat: this.$vuetify.breakpoint.mdAndUp && this.meetingInfo.isRepeat,
          repeatInfo: this.meetingInfo.repeatInfo,
        }

        await this.$http.get('/api/v1/rooms/duplicate', {params: params}).then(response => {
          this.rooms = response.data
          this.roomLoading = false
        }).catch(error => {
          console.log(error)
          this.roomLoading = false
        })
      }
    },
    setCombobox(isToday, isEdit) {
      this.startTimeList = this.timeComboboxBind(true, isToday)
      this.endTimeList = this.timeComboboxBind(false, isToday)
      this.meetingInfo.startTime = isEdit ? this.meetingInfo.startTime : this.startTimeList[0]
      this.meetingInfo.endTime = isEdit ? this.meetingInfo.endTime : this.endTimeList[0]
    },
    timeComboboxBind(isStart, isToday) {
      const todayStartTime = nearestFutureMinutes(30, moment())
      const dayStartTime = moment().startOf('d')
      const dayEndTime = moment().endOf('d')
      let source = null
      let dest = null
      if (isToday) {
        if (isStart) {
          source = todayStartTime.clone()
          dest = dayEndTime.clone()
        } else {
          source = todayStartTime.clone().add(30, 'minutes')
          dest = dayEndTime.clone().add(1, 'minutes')
        }
      } else {
        if (isStart) {
          source = dayStartTime.clone()
          dest = dayEndTime.clone()
        } else {
          source = dayStartTime.clone().add(30, 'minutes')
          dest = dayEndTime.clone().add(1, 'minutes')
        }
      }

      const results = []
      while (source <= dest) {
        results.push(source.format('HH:mm'))
        source = source.clone().add(30, 'minutes')
      }
      return results
    },
    getCurrentTime() {
      return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
    },
    scrollToTime() {
      const time = this.getCurrentTime()
      const first = Math.max(0, time - (time % 30) - 30)

      this.cal.scrollToTime(first)
    },
    updateTime() {
      setInterval(() => this.cal.updateTimes(), 60 * 1000)
    },
    allowedDates(d) {
      return moment(d).format('YYYY-MM-DD') >= moment().format('YYYY-MM-DD')
    },
    allowedEndDates(d) {
      const startDate = moment(this.meetingInfo.reservedDate)
      const startIndex = this.startTimeList.findIndex(time => time === this.meetingInfo.startTime)
      const lastIndex = this.startTimeList.length - 1
      if (startIndex === lastIndex) {
        return moment(d).format('YYYY-MM-DD') > startDate.format('YYYY-MM-DD')
      }
      return moment(d).format('YYYY-MM-DD') >= startDate.format('YYYY-MM-DD')
    },
    async reservedDateChange(date) {
      const isToday = date === moment().format('YYYY-MM-DD')
      this.startTimeList = this.timeComboboxBind(true, isToday)

      if (moment(`${date} ${this.meetingInfo.startTime}`) > moment(`${this.meetingInfo.reservedEndDate} ${this.meetingInfo.endTime}`)) {
        // this.meetingInfo.reservedEndDate = moment(date).add(1, 'days').format('YYYY-MM-DD')
        if (this.meetingInfo.startTime === this.startTimeList[this.startTimeList.length - 1]) {
          this.meetingInfo.reservedEndDate = moment(date).add(1, 'days').format('YYYY-MM-DD')
        } else {
          this.meetingInfo.reservedEndDate = date
        }
        this.endTimeList = this.timeComboboxBind(false, isToday)
      }
      this.meetingInfo.repeatInfo.endDate = date
      await this.getRooms()
      await this.getMeetings()
    },
    async reservedEndDateChange(date) {
      const isToday = date === moment().format('YYYY-MM-DD')
      this.endTimeList = this.timeComboboxBind(false, isToday)

      const startIndex = this.startTimeList.findIndex(time => time === this.meetingInfo.startTime)
      const endIndex = this.endTimeList.findIndex(time => time === this.meetingInfo.endTime)
      if (startIndex > endIndex) {
        this.meetingInfo.endTime = this.endTimeList[startIndex]
      }
      if (this.meetingInfo.reservedDate === date) {
        this.meetingInfo.endTime = this.endTimeList[startIndex]
      }
      await this.getRooms()
    },
    async startTimeChange(startTime) {
      const startIndex = this.startTimeList.findIndex(time => time === startTime)
      const endIndex = this.endTimeList.findIndex(time => time === this.meetingInfo.endTime)
      const lastIndex = this.startTimeList.length - 1
      if (startIndex > endIndex) {
        this.meetingInfo.endTime = this.endTimeList[startIndex]
      }

      if (startIndex === lastIndex) {
        const startDtime = moment(`${this.meetingInfo.reservedDate} ${this.meetingInfo.startTime}`)
        const endDtime = moment(`${this.meetingInfo.reservedEndDate} ${this.meetingInfo.endTime}`)
        if (startDtime > endDtime) {
          this.meetingInfo.reservedEndDate = startDtime.add(1, 'days').format('YYYY-MM-DD')
          this.endTimeList = this.timeComboboxBind(false, false)
        }
      }
      await this.getRooms()
    },
    async endTimeChange(endTime) {
      const startDtime = moment(`${this.meetingInfo.reservedDate} ${this.meetingInfo.startTime}`)
      const endDtime = moment(`${this.meetingInfo.reservedEndDate} ${this.meetingInfo.endTime}`)
      if (startDtime >= endDtime) {
        const endIndex = this.endTimeList.findIndex(time => time === endTime)
        this.meetingInfo.startTime = this.startTimeList[endIndex]
      }
      await this.getRooms()
    },
    async reserveMeeting() {
      // console.log('reserveMeeting start !!')

      if (!this.isFormValid) {
        snackbarOpen('pink', '회의명과 일시, 회의실은 필수 입력값입니다.', 'error')
        return
      }
      if (this.meetingInfo.roomIds.length < 1) {
        snackbarOpen('pink', '회의실은 필수 입력값입니다.', 'error')
        return
      }
      console.log(this.meetingInfo)
      // 공용 회의실 유무 체크
      if (this.meetingInfo.roomIds.isPublic) {
        const publicRooms = await this.$http.post('/api/v1/rooms/getRooms/byPublic').then(response => {
          const hasValue = response.data.some(item => item._id === this.meetingInfo.roomIds._id);
          return hasValue;
        }).catch(error => {
          console.error(error)
        })
        if (publicRooms) {
          this.meetingInfo.publicReservedType = true
        }
      }

      console.log('this.meetingInfo.publicReservedType :: ' + this.meetingInfo.publicReservedType)

      this.meetingInfo.startDtime = moment(`${this.meetingInfo.reservedDate} ${this.meetingInfo.startTime}`).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      this.meetingInfo.endDtime = moment(`${this.meetingInfo.reservedEndDate} ${this.meetingInfo.endTime}`).utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z'
      if (this.meetingInfo.isRepeat) {
        const startDtime = moment(this.meetingInfo.startDtime)
        const endDtime = moment(this.meetingInfo.endDtime)
        const timeDiff = moment.duration(endDtime.diff(startDtime)).asHours()
        if (timeDiff > 24) {
          snackbarOpen('pink', '반복예약시 예약기간은 1일 이내 입니다.', 'error')
          return
        }
      }
      this.loading = true
      if (this.meetingInfo.creator.email === '') {
        this.meetingInfo.creator = {
          companyName: this.info.companyName,
          email: this.info.email,
          username: this.info.username,
          displayName: this.info.username,
          displayFullName: this.info.username,
        }
      }


      const data = {
        ...this.meetingInfo,
        roomIds: Array.isArray(this.meetingInfo.roomIds)
          ? this.meetingInfo.roomIds
          : [this.meetingInfo.roomIds],
        attendees: this.meetingInfo.attendees.map(attendee => {
          return {
            email: attendee.email,
            username: attendee.name,
            displayName: attendee.name,
            displayFullName: attendee.name,
          }
        }),
        status: this.meetingInfo.roomIds.isUseApprove ? 'q' : 'r',
      }

      console.log('this.publicReservedType :: ' + this.publicReservedType)
      console.log("this.isEdit = " + this.isEdit)

      if (this.isEdit) {
        await this.$http.put('/api/v1/meetings', data).then(response => {
          this.$router.push('/list/')
        }).catch(error => {
          alert(error.response.data);
          console.log(error)
        })
      } else {
        await this.$http.post('/api/v1/meetings', data).then(response => {
          this.$router.push('/list/')
        }).catch(error => {
          const data = error.response.data
          const reason = {
            startDtime: moment(data.startDtime).format('YYYY-MM-DD HH:mm'),
            endDtime: moment(data.endDtime).format('HH:mm'),
          }
          snackbarOpen('pink', `${this.meetingInfo.isRepeat ? '반복 예정된 일정 중 ' : ''}${reason.startDtime}~${reason.endDtime} 시간의 예약이 중복되었습니다.`, 'error')
        })
      }

      this.loading = false
    },
    async cancelMeeting() {
      await this.$http.delete(`/api/v1/meetings/${this.$route.query.meetingId}`).then(response => {
        this.$router.go(-1)
      }).catch(error => {
        console.log(error)
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    repeatInfoDialogClose(result) {
      if (result === 'save') {
        this.meetingInfo.isRepeat = true
        this.meetingInfo.isScheduled = true
      } else {
        this.meetingInfo.isRepeat = false
        this.meetingInfo.isScheduled = false
        this.customDialog.dialog = false
        this.getRooms()
        return
      }
      if (!this.customDialog.isFormValid) {
        // snackbar
        console.log('valid false')
        return
      }
      if (this.meetingInfo.repeatInfo.type === 'WEEKLY' &&
        this.meetingInfo.repeatInfo.byDay.length < 1) {
        return
      }
      this.customDialog.dialog = false
      this.getRooms()
    },
    repeatTypeChanged(type) {
      if (type === 'DAILY') {
        this.meetingInfo.repeatInfo.byDay = null
      }
      this.meetingInfo.repeatInfo.interval = 1
    },
    byDayChanged() {
      if (this.meetingInfo.repeatInfo.byDay.length < 1) {
        this.meetingInfo.repeatInfo.byDay = null
        return
      }
      this.meetingInfo.repeatInfo.byDay.sort((a, b) => {
        return a - b
      })
    },
    allowedRepeatDates(d) {
      return (moment(d).format('YYYY-MM-DD') >= moment(this.meetingInfo.reservedDate).format('YYYY-MM-DD') &&
        moment(d).format('YYYY-MM-DD') <= moment(this.meetingInfo.reservedDate).add(3, 'months').format('YYYY-MM-DD'))
    },
    chipClose(type, item) {
      const index = this.meetingInfo.attendees.findIndex(attendee => attendee.email === item.email)
      if (index > -1) {
        this.meetingInfo.attendees.splice(index, 1)
      }
    },
    searchPeople(val) {
      // 공용 회의실 선택 시 상대방 회사 인원 조회 처리
      // 2022-01-10 이수용 과장님 확인
      // - 보류 (추후 업체 요청으로 별도 개발 예정)
      // const roomId = this.meetingInfo.roomIds._id
      // console.log(JSON.stringify(roomId))

      const search = val
      let searchLength = 4
      const check = /[ㄱ-ㅎ]|[ㅏ-ㅣ]|[가-힣]/
      if (check.test(search)) {
        searchLength = 2
      }
      // console.log(check.test(search), search, searchLength);
      if (search === null || search === '' || search.length < searchLength) {
        // console.log('people clear');
        this.people = []
        return
      }
      this.searchUser(search.trim())
    },
    searchUser: debounce(async function (text) {
      await this.$http.get('/api/v1/organizations', {params: {search: text, limit: 100}}).then(response => {
        this.people = response.data.splice(0, 100)
        this.lastSearchPeople = [...this.people]
      }).catch(error => {
        console.log(error)
      })
    }, 200),
    getEventColor(event) {
      return event.color
    },
    async getMeetings() {
      // console.log('getMeetings Start !!')
      if (!this.meetingInfo.roomIds._id) return
      // console.log('getMeetings return Pass !!')
      const params = {
        isCalendar: true,
        email: this.info.email,
        startDtime: moment(this.$refs.calendar.lastStart.date).subtract(6, 'days').startOf('d').utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
        endDtime: moment(this.$refs.calendar.lastEnd.date).add(6, 'days').endOf('d').utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
        roomId: this.meetingInfo.roomIds._id,
      }

      await this.$http.get('/api/v1/meetings', { params: params }).then(response => {
        this.meetings = response.data.map(meeting => {
          return {
            ...meeting,
            start: new Date(meeting.startDtime),
            end: new Date(meeting.endDtime),
            name: meeting.title,
            timed: true,
          }
        })
      }).catch(err => {
        console.log(err)
      })
    },
    async renderChartMeeting(){
      // console.log('getMeetings Start !!')
      if (!this.meetingInfo.roomIds._id) return
      // console.log('getMeetings return Pass !!')
      const params = {
        isCalendar: true,
        email: this.info.email,
        startDtime: moment(this.$refs.calendar.lastStart.date).subtract(6, 'days').startOf('d').utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
        endDtime: moment(this.$refs.calendar.lastEnd.date).add(6, 'days').endOf('d').utc().format('YYYY-MM-DDTHH:mm:ss') + 'Z',
        roomId: this.meetingInfo.roomIds._id,
      }

      await this.$http.get('/api/v1/meetings', {params: params}).then(response => {

        this.meetings = response.data.map(meeting => {
          console.log(meeting)
          if (meeting.roomIds[0]._id === params.roomId) {
            return {
              ...meeting,
              start: new Date(meeting.startDtime),
              end: new Date(meeting.endDtime),
              name: meeting.title,
              timed: true,
            }
          }
          return null;
        }).filter(meeting => meeting !== null);
      }).catch(err => {
        console.log(err)
      })
    },
    async changeRoom() {
      await this.renderChartMeeting()
    },
    async availableRooms() {
      await this.getRooms()

      const room = this.rooms.find(room => room._id === this.meetingInfo.roomIds._id)
      if (room) {
        await this.getMeetings()
      } else {
        this.meetings = []
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.mb-minus-20 {
  margin-bottom: -20px;
}

.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;

  &.first::before {
    content: '';
    position: absolute;
    background-color: #ea4335;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: -5px;
    margin-left: -6.5px;
  }
}

</style>
